// Light, dark, or whatever the device is set to. System is the default and
// is stored as no value at all, so a phone that turns dark at sunset takes
// the app along.

export type ThemeMode = 'light' | 'dark' | 'system'

/** The localStorage key. The pre-paint script in nuxt.config.ts reads it too */
export const THEME_STORAGE_KEY = 'kb-theme'

/**
 * The key up to 5.0.2. The login page wrote the device's setting into it
 * for anyone without one, so it rarely records a choice; it is removed
 * instead of carried over.
 */
export const LEGACY_THEME_STORAGE_KEY = 'theme'

export const THEME_MODES: readonly { value: ThemeMode, label: string, icon: string }[] = [
  { value: 'light', label: 'Light', icon: 'pi-sun' },
  { value: 'dark', label: 'Dark', icon: 'pi-moon' },
  { value: 'system', label: 'System', icon: 'pi-desktop' },
]

export function parseThemeMode(stored: string | null | undefined): ThemeMode {
  return stored === 'light' || stored === 'dark' ? stored : 'system'
}

export function themeIsDark(mode: ThemeMode, systemDark: boolean): boolean {
  return mode === 'dark' || (mode === 'system' && systemDark)
}

/** The one-button switch (the collapsed sidebar): system → light → dark */
export function nextThemeMode(mode: ThemeMode): ThemeMode {
  if (mode === 'system') return 'light'
  if (mode === 'light') return 'dark'
  return 'system'
}

export function themeModeOption(mode: ThemeMode) {
  return THEME_MODES.find(option => option.value === mode)!
}
